<template>
  <div v-if="isVisible" class="gwp-line-item">
    <slot :click-handler="clickHandler" />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("cart", ["cartData"]),
    isVisible() {
      // Both reactive reads happen before the localStorage one, and that order
      // matters: a computed only tracks what it actually read, so returning on
      // the flag first left this one tracking nothing at all — it stayed false
      // for good, and the offer never came back when the gift was taken out of
      // the cart. It went unnoticed while the theme re-rendered the whole
      // drawer from the server after every change, which rebuilt this
      // component from scratch.
      const giftInCart = !!this.cartData?.items?.some(
        (i) => !!i?.properties?._gwp
      );
      const offered = !!this.$store.state.gwp?.visible;

      if (window.localStorage.getItem("gwpAdded") === "yes") return false;

      return !giftInCart && offered;
    },
  },
  methods: {
    clickHandler(product) {
      this.$store.dispatch("gwp/addToCart", product);
    },
  },
};
</script>
